import { ProductPage } from "./ModeloAlfa";
import { LayoutGrid, Snowflake, Ruler } from "lucide-react";
import { usePageContent, useContentList } from "@/context/CmsContext";
import { useLocale } from "@/context/LocaleContext";
import useSeo from "@/lib/useSeo";

const GALLERY_FALLBACK_OMEGA = [
    { url: "/brand/omega-hero.jpg", alt: "Modelo Ômega vista completa" },
    { url: "/brand/omega-product.jpg", alt: "Modelo Ômega product shot" },
];

const NO_CANOPY_OMEGA = [
    { url: "/brand/omega-no-canopy.jpg", alt: "Modelo Ômega sem cobertura" },
    { url: "/brand/omega-product-no-canopy.jpg", alt: "Modelo Ômega sem cobertura — product shot" },
];

export default function ModeloOmega() {
    const { t } = usePageContent("modelo_omega");
    const { tr, fmtPrice } = useLocale();
    const gallery = useContentList("omega_gallery", GALLERY_FALLBACK_OMEGA, { forceFallbackEn: false });
    const images = gallery.map((g) => g.url).filter(Boolean);
    const mainImg = t("hero", "main_image", "");
    const finalImages = mainImg && !images.includes(mainImg) ? [mainImg, ...images] : (images.length ? images : [mainImg || "/brand/omega-hero.jpg"]);

    useSeo({
        title: tr("Modelo Ômega — Food cart grande premium", "Omega Model — Premium large food cart"),
        description: tr(
            "Carrinho grande NOVIFOOD Ômega: 1,98 m, bancada extensa para multi-equipamento. Operação a 2, café + freezer + grelhador em simultâneo. Desde €3.000.",
            "NOVIFOOD Omega large cart: 1.98 m, extended counter for multi-equipment. 2-person operation, coffee + freezer + grill simultaneously. From €3,000."
        ),
        path: "/modelo-omega",
        type: "product",
        image: mainImg || "/brand/omega-hero.jpg",
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "NOVIFOOD Modelo Ômega",
            "description": "Carrinho grande NOVIFOOD Ômega: 1,98 m, multi-equipamento, operação 2 pessoas.",
            "brand": { "@type": "Brand", "name": "NOVIFOOD" },
            "offers": {
                "@type": "Offer",
                "priceCurrency": "EUR",
                "price": "3000",
                "availability": "https://schema.org/InStock",
                "url": "https://novifood.pt/modelo-omega",
            },
        },
    });

    return (
        <ProductPage
            pageId="modelo_omega"
            name={t("hero", "eyebrow", tr("Modelo Ômega", "Omega Model"))}
            title={t("hero", "title", tr("Maior volume, máximo retorno.", "Higher volume, maximum return."))}
            tag={t("hero", "eyebrow", tr("Modelo Ômega", "Omega Model"))}
            price={fmtPrice(3000)}
            delivery={t("hero", "delivery", tr("Entrega em 30-45 dias", "Delivery in 30-45 days"))}
            warranty={t("hero", "warranty", tr("Garantia 2 anos", "2-year warranty"))}
            tagline={t("hero", "subtitle", tr("Mais espaço, mais equipamento — para quem quer levar a operação a sério.", "More space, more equipment — for those serious about their operation."))}
            ctaLabel={t("hero", "cta_label", tr("Pedir orçamento", "Request a quote"))}
            ctaTo={t("hero", "cta_to", "/contacto")}
            images={finalImages}
            imagesNoCanopy={NO_CANOPY_OMEGA.map((g) => g.url)}
            specs={[
                { icon: Ruler, title: tr("Tamanho", "Size"), text: t("specs", "size", "1,98 m × 0,90 m") },
                { icon: Ruler, title: tr("Peso", "Weight"), text: t("specs", "weight", "~150 kg") },
                { icon: Snowflake, title: tr("Energia", "Energy"), text: t("specs", "energy", tr("Solar + bateria 2 kWh", "Solar + 2 kWh battery")) },
                { icon: Snowflake, title: tr("Refrigeração", "Cooling"), text: t("specs", "cooling", tr("Freezer + isotérmico integrados", "Integrated freezer + isothermal")) },
                { icon: LayoutGrid, title: tr("Estrutura", "Structure"), text: t("specs", "structure", tr("Alumínio reforçado · acabamento premium", "Reinforced aluminium · premium finish")) },
            ]}
        />
    );
}
